/* ==========================================================================
   OPTIMUS: Homepage Performance Optimizer
   ==========================================================================
   Viewport-gates Slick autoplay timers to prevent off-screen GPU compositing.
   Sliders only autoplay when visible; timers are paused when scrolled away.
   ========================================================================== */

(function() {
  'use strict';

  /* --- Fix 1: Viewport-Gate Slick Autoplay ---
     Observe all Slick-initialized sliders with autoplay enabled.
     Pause when off-screen, resume when entering viewport.
     Uses polling to catch late-initializing Slick instances.
  ---------------------------------------------------------------- */
  function initSlickViewportGating() {
    // Slick may not be initialized yet on DOMContentLoaded, so we poll
    var maxAttempts = 20;
    var attempt = 0;
    var observedSliders = new WeakSet();

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        var $slider = window.jQuery ? window.jQuery(entry.target) : null;
        if (!$slider || !$slider.length) return;

        // Find the actual slick-initialized element
        var $slick = $slider.hasClass('slick-initialized')
          ? $slider
          : $slider.find('.slick-initialized').first();

        if (!$slick.length) return;

        try {
          var slickInstance = $slick.slick('getSlick');
          if (!slickInstance || !slickInstance.options.autoplay) return;

          if (entry.isIntersecting) {
            $slick.slick('slickPlay');
          } else {
            $slick.slick('slickPause');
          }
        } catch(e) {
          // Slick not ready or destroyed — ignore silently
        }
      });
    }, {
      rootMargin: '100px 0px',
      threshold: 0
    });

    function scanForSliders() {
      // Target product-block wrappers and spotlight-block sliders
      var selectors = [
        '.halo-product-block .products-carousel.slick-initialized',
        '.spotlight-block .halo-row.slick-initialized',
        '.product-tab-block .products-carousel.slick-initialized'
      ];

      selectors.forEach(function(selector) {
        var elements = document.querySelectorAll(selector);
        elements.forEach(function(el) {
          if (!observedSliders.has(el)) {
            observedSliders.add(el);
            // Observe the parent section for better viewport detection
            var section = el.closest('section') || el.closest('.shopify-section') || el.parentElement;
            if (section && !observedSliders.has(section)) {
              observedSliders.add(section);
              observer.observe(section);
            }
          }
        });
      });

      attempt++;
      if (attempt < maxAttempts) {
        setTimeout(scanForSliders, 500);
      }
    }

    // Start scanning after a short delay to let Slick initialize
    setTimeout(scanForSliders, 1000);
  }

  /* --- Fix 2: Throttle Zoom-In Scroll Handler ---
     The original animations.js fires on every scroll pixel.
     We patch it with a frame-budget-aware throttle that skips 
     redundant updates when the zoom element hasn't moved significantly.
  ---------------------------------------------------------------- */
  function patchZoomScrollThrottle() {
    // We can't modify animations.js directly here, but we can add a
    // performance guard: if the slideshow is the only zoom-in element
    // and it's scrolled off-screen, remove any lingering scroll listeners.
    // This is handled by augmenting the zoom observer behavior.

    var zoomElements = document.querySelectorAll('.animate--zoom-in');
    if (!zoomElements.length) return;

    var zoomObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) {
          // Force reset zoom ratio when element leaves viewport
          // This prevents stale GPU layers from being held
          entry.target.style.setProperty('--zoom-in-ratio', '1');
        }
      });
    }, {
      rootMargin: '50px 0px',
      threshold: 0
    });

    zoomElements.forEach(function(el) {
      zoomObserver.observe(el);
    });
  }

  /* --- Initialize on DOM ready --- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initSlickViewportGating();
      patchZoomScrollThrottle();
    });
  } else {
    initSlickViewportGating();
    patchZoomScrollThrottle();
  }
})();
